// src/components/Layout.js
import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { signOut } from 'firebase/auth';

function Layout() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (auth.currentUser) {
        const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid));
        setUserData(userDoc.data());
      }
    };
    fetchUser();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Cabeçalho */}
      <header
        className="text-white p-4 flex justify-between items-center"
        style={{ backgroundColor: '#d5c1b6' }}
      >
        <button
          onClick={() => navigate('/projects')}
          className="flex items-center space-x-2"
        >
          <img
            src={require('../assets/logo.png')}
            alt="Logo Bruna Bündchen"
            className="h-10"
          />
        </button>

        <div className="flex space-x-4">
          {userData?.role === 'admin' && (
            <>
              <button
                onClick={() => navigate('/admin')}
                className="w-full bg-[#b29d92] hover:bg-[#b29d92] text-white px-3 py-1 rounded font-semibold"
              >
                Admin
              </button>

              <button
                onClick={() => navigate('/revenue-dashboard')}
                className="w-full bg-[#b29d92] hover:bg-[#b29d92] text-white px-3 py-1 rounded font-semibold"
              >
                Receitas
              </button>
            </>
          )}

          <button
            onClick={handleLogout}
            className="w-full bg-[#b29d92] hover:bg-[#b29d92] text-white px-3 py-1 rounded font-semibold"
          >
            Sair
          </button>
        </div>
      </header>

      {/* Conteúdo principal */}
      <main className="flex-1 p-4">
        <Outlet />
      </main>

      {/* Rodapé */}
      <footer
        className="text-white p-4 text-center"
        style={{ backgroundColor: '#d5c1b6' }}
      >
        <p>&copy; {new Date().getFullYear()} Bündchen Arquitetura</p>
      </footer>
    </div>
  );
}

export default Layout;
